import { SxProps, Theme } from '@mui/material/styles';

// Common container styles
export const ATTENDANCE_STYLES = {
  // Main container
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    mt: 12,
    mb: 10,
  } as SxProps<Theme>,

  // Content wrapper
  contentWrapper: {
    display: "flex",
    justifyContent: "center",
    maxWidth: "1600px",
    margin: "0 auto",
    padding: "0 16px",
    width: "100%",
  } as SxProps<Theme>,

  // Summary card base
  summaryCardBase: {
    height: "100%",
    boxShadow: 2,
  } as SxProps<Theme>,

  // Summary card content
  summaryCardContent: (isMobile: boolean) => ({
    p: isMobile ? 2 : 3,
  }) as SxProps<Theme>,

  // Enhanced summary card (with hover effects)
  enhancedSummaryCard: {
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    borderRadius: 2,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    minHeight: 120,
    transition: 'transform 0.2s, boxShadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    }
  } as SxProps<Theme>,

  // DataGrid paper wrapper
  dataGridPaper: {
    borderRadius: 2,
    overflow: "hidden",
    margin: "0 auto",
    elevation: 2,
  } as SxProps<Theme>,

  // Filter section
  filterSection: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mb: 4,
    p: 2,
    backgroundColor: "#fafafa",
    borderRadius: 2,
    width: "100%",
  } as SxProps<Theme>,

  // Chart container
  chartContainer: {
    mt: 4,
    mb: 4,
    p: 2,
    backgroundColor: "white",
    borderRadius: 2,
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    width: "100%",
    minHeight: "450px",
  } as SxProps<Theme>,

  // Date picker styles
  datePicker: {
    ".MuiInputLabel-root": {
      transform: "translate(14px, 8px) scale(1)",
    },
    ".MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
    ".MuiInputBase-root .MuiInputBase-input": {
      height: "0.55rem",
      width: "8rem",
    },
    mx: 1,
  } as SxProps<Theme>,
};

// DataGrid common styles
export const DATA_GRID_STYLES = {
  headerBackground: "header-background",
  customHeaderStyle: (fontSize: number = 15) => ({
    fontSize,
    fontWeight: 'bold',
  }),
  
  // Common DataGrid props
  commonProps: {
    autoHeight: true,
    disableColumnMenu: true,
    sx: {
      width: "100%",
      height: "100%",
      "--DataGrid-overlayHeight": "50vh",
      "& .MuiDataGrid-root": {
        borderRadius: 1,
      },
    },
  },
};

// Typography styles
export const TYPOGRAPHY_STYLES = {
  pageTitle: {
    fontWeight: 600,
    mb: 2,
  } as SxProps<Theme>,
  
  sectionTitle: {
    fontWeight: 600,
    mb: 2,
  } as SxProps<Theme>,
  
  summaryCardTitle: (isMobile: boolean) => ({
    variant: isMobile ? "body2" : "subtitle2",
    color: "black",
    gutterBottom: true,
  }),
  
  summaryCardValue: (isMobile: boolean) => ({
    variant: isMobile ? "h6" : "h5",
    fontWeight: "medium",
  }),
};